module.exports = __webpack_public_path__ + "img/WP2023-RegOpen-landscape-1200-630.8b8828a4.png";